import { BdStringShortener } from '../string/string-shortener';

export class BdExportAsFileExcelHelper {
  /**
   * Characters SheetJS actually rejects in a sheet name (`check_ws_name`'s
   * `badchars`, node_modules/xlsx/xlsx.mjs). Keep this list aligned with that
   * function instead of guessing — Excel allows `<`, `>` and `&`, so they must
   * NOT be in this list, and `?` must be.
   */
  private static readonly ILLEGAL_CHARACTERS_IN_SHEET_NAME = [
    ':',
    ']',
    '[',
    '*',
    '?',
    '/',
    '\\',
  ];

  /** Sheet name SheetJS reserves internally; `check_ws_name` rejects it case-insensitively. */
  private static readonly RESERVED_SHEET_NAME = 'history';

  private static readonly MAX_SHEET_NAME_LENGTH = 31;
  private static readonly DEFAULT_SHEET_NAME = 'Export';

  public static sanitizeSheetName(
    sheetName: string,
    maxSheetNameLength = this.MAX_SHEET_NAME_LENGTH,
  ): string {
    if (!sheetName || sheetName.length === 0) {
      sheetName = this.DEFAULT_SHEET_NAME;
    }

    // `.replace(char, ' ')` with a string pattern only replaces the FIRST
    // occurrence — split/join replaces every occurrence (BDA-5941).
    this.ILLEGAL_CHARACTERS_IN_SHEET_NAME.forEach((illegalCharacter) => {
      sheetName = sheetName.split(illegalCharacter).join(' ');
    });

    // SheetJS also rejects a leading/trailing apostrophe.
    sheetName = sheetName.replace(/^'+|'+$/g, '');

    if (sheetName.length === 0) {
      sheetName = this.DEFAULT_SHEET_NAME;
    }

    sheetName = BdStringShortener.process(sheetName, maxSheetNameLength);

    // SheetJS also rejects the reserved name "History" (case-insensitive).
    if (sheetName.toLowerCase() === this.RESERVED_SHEET_NAME) {
      sheetName = `${sheetName}_`;
    }

    return sheetName;
  }
}
